<div style="padding: 32px 40px 40px 40px;max-width: 1078px">
  <div class="title-large" data-testid="title" style="margin-bottom: 32px">App Ratings</div>

  <section style="display: flex;  gap: 16px; margin-bottom:16px; ">
    <div class="card" data-testid="iosRatingCard" style="width: 100%">
      <div class="card-body">
        <div
          style="display: flex;justify-content: space-between;padding-top: 8px;flex-direction: column;align-items: center;gap: 8px">
          <div class="title-large" style=" font-weight: 700">{{ latestIOSRating }}</div>
          <div class="card-header">IOS</div>
        </div>
      </div>
    </div>
    <div class="card" data-testid="androidRatingCard" style="width: 100%">
      <div class="card-body">
        <div
          style="display: flex;justify-content: space-between;padding-top: 8px;flex-direction: column;align-items: center;gap: 8px">
          <div class="title-large" style=" font-weight: 700">{{ latestAndroidRating }}</div>
          <div class="card-header">Android</div>
        </div>
      </div>
    </div>
  </section>

  <label for="yearsDropdown">Selected year</label>
  <select (change)="onYearChanged()" [(ngModel)]="selectedYear" data-testid="yearsDropdown" id="yearsDropdown"
          style="display: block;margin: 8px 0 16px 0; min-width: 150px">
    <option value="all">All</option>

    @for (date of dropdownYears; track date) {
      <option [value]="date">{{ date }}</option>
    }
  </select>

  <div
    style=" padding: 16px;height: 400px; border-radius: 8px; background: #f9f9f9">
    <canvas data-testid="barChart" id="ratingChart">
      {{ barChart }}
    </canvas>
  </div>

</div>
